import { z } from 'zod';
import { baseEmailDTOSchema } from './base-email-dto';

export const trialEmailSchemas = [
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('welcome_trial'),
    data: z.object({
      name: z.string().min(1),
      organizationDisplayName: z.string().min(1),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('trialExpirationWarning'),
    data: z.object({
      name: z.string().min(1),
      organizationDisplayName: z.string().min(1),
      daysRemaining: z.number().positive(),
      locale: z.string().optional(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('trialExtended'),
    data: z.object({
      name: z.string().min(1),
      organizationDisplayName: z.string().min(1),
      endDate: z.string().min(1),
      locale: z.string().optional(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('trialExpired'),
    data: z.object({
      name: z.string().min(1),
      organizationDisplayName: z.string().min(1),
    }),
  }),
] as const;
